// extracted by mini-css-extract-plugin
export default {"grid":"VK_AOkZdx2N8RtqsCkiw","buttons":"x0HeuuGwEpVgbLdCkD57"};